import React from 'react';
import { SearchIcon } from '../icons';

/**
 * SearchHeader - Search input with clear button
 */
const SearchHeader = ({ 
  inputRef, 
  searchQuery, 
  onSearchChange, 
  onClear 
}) => {
  return (
    <div className="unified-search-popup__header">
      <div className="unified-search-popup__search">
        <SearchIcon size={14} />
        <input
          ref={inputRef}
          type="text"
          className="unified-search-popup__input"
          placeholder="Search campaigns and missions..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchQuery && (
          <button 
            className="unified-search-popup__clear"
            onClick={onClear}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;
